import axios from "axios";
import {
  AgentCupListRequestBody,
  CifCupsAgentResponse,
  GetCifCupsRequestBody,
  GetCifCupsResponse,
} from "../../models/cupsCifSelector/cupsCifSelector.model";
import { API_ENDPOINTS } from "../../../config/endpoints.config";

const getCifCups = async (
  requestBody: GetCifCupsRequestBody,
  token: string,
  abortSignal?: AbortSignal
): Promise<GetCifCupsResponse[]> =>
  await axios
    .post(API_ENDPOINTS.CLIENT_CIFS_CUPS, requestBody, {
      headers: {
        Authorization: token,
      },
      signal: abortSignal,
    })
    .then(({ data }) => data)
    .catch((error) => {
      throw error;
    });

const getCifCupsForAgent = async (
  body: Omit<AgentCupListRequestBody, "type">,
  token: string,
  abortSignal?: AbortSignal
): Promise<CifCupsAgentResponse> => {
  const requestBody: AgentCupListRequestBody = {
    type: 1,
    pageIndex: body.pageIndex ?? 0,
    pageSize: body.pageSize ?? 100,
    identities: body.identities,
  };
  return await axios
    .post(API_ENDPOINTS.USER_MASTER_DATA, requestBody, {
      headers: {
        Authorization: token,
      },
      signal: abortSignal,
    })
    .then(({ data }) => data)
    .catch((error) => {
      throw error;
    });
};

export { getCifCups, getCifCupsForAgent };
